var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnnouncementBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33317 8.16674L3.25171 11.8409C3.27755 11.9442 3.29046 11.9959 3.30574 12.041C3.45502 12.4817 3.85189 12.7916 4.31564 12.8295C4.36311 12.8334 4.41637 12.8334 4.52288 12.8334C4.65626 12.8334 4.72295 12.8334 4.77913 12.828C5.33442 12.7741 5.77387 12.3347 5.82772 11.7794C5.83317 11.7232 5.83317 11.6565 5.83317 11.5231V3.2084M10.7915 7.87507C11.9191 7.87507 12.8332 6.96099 12.8332 5.8334C12.8332 4.70582 11.9191 3.79174 10.7915 3.79174M5.979 3.2084H3.7915C2.34176 3.2084 1.1665 4.38366 1.1665 5.83341C1.1665 7.28315 2.34176 8.4584 3.7915 8.4584H5.97901C7.00942 8.4584 8.2699 9.01075 9.24234 9.54086C9.80965 9.85012 10.0933 10.0047 10.2791 9.98199C10.4514 9.9609 10.5816 9.88354 10.6826 9.74238C10.7915 9.59016 10.7915 9.28557 10.7915 8.6764V2.9904C10.7915 2.38123 10.7915 2.07665 10.6826 1.92442C10.5816 1.78326 10.4514 1.70591 10.2791 1.68481C10.0933 1.66206 9.80965 1.81669 9.24234 2.12594C8.2699 2.65605 7.00942 3.2084 5.979 3.2084Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncementBlue);
export default __webpack_public_path__ + "static/media/IconAnnouncementBlue.8a156c1cf408e8ea5a26fa74a24a930a.svg";
export { ForwardRef as ReactComponent };